import React, { Dispatch } from 'react';
import { IState } from '../../models/components/lesson-upcoming-activity';
import { IAction, IAppState } from '../../models/action/core';
import { connect } from 'react-redux';
import { IListForumProps } from '../../models/components/list-forum';
import Translator from '../../core/i18n';
import { Log } from 'ng2-logger';
import { getForumConversation, getForumMessage, setForumMessageDefault } from '../../store/actions/forum';
import { ForumThreadType } from '../../models/enums/forumThreadType';
import Loading from '../loading/loading';
import { Common } from '../../core/common';
import { SecurityContextType, SecurityPermissionType } from '../../core/SecurityContext';
import queryString from 'querystring';
import Moment from 'moment';
import ContentLoader from 'react-content-loader';
import ReactGA from 'react-ga4';

const T = Translator.create();
const _logger = Log.create('listForum.tsc');
const _common: Common = new Common();

class ListForum extends React.Component<IListForumProps> {
    state = { currentTab: 'general', selectedForum: '', isSearchBoxOpen: false, searchedWord: '', isSearchBoxShow: false };

    constructor(props: any) {
        super(props);
        if (T.i18next.language === 'tr') {
            Moment.locale('tr');
        }
        if (T.i18next.language === 'en') {
            Moment.locale('en');
        }
    }

    public onTabChange = (event: any) => {
        if (event.target!.getAttribute('data-tabtype').toString() === 'general') {
            ReactGA.event({
                category: window.location.host,
                action: 'G_GENERAL_FORUM_CLICKED',
                label: 'G_GENERAL_FORUM_CLICKED',
                nonInteraction: true,
            });
            this.setState({ currentTab: 'general', selectedForum: '' });
            this.props.dispatch(getForumConversation(15, 0, ForumThreadType.Organization, '', 'getForumConversation', 'get', undefined, undefined, ['getForumMessage'], this.props.actId ?? ""));
        } else if (event.target!.getAttribute('data-tabtype').toString() === 'course') {
            ReactGA.event({
                category: window.location.host,
                action: 'G_COURSE_FORUM_CLICKED',
                label: 'G_COURSE_FORUM_CLICKED',
                nonInteraction: true,
            });
            this.setState({ currentTab: 'course', selectedForum: '' });
            this.props.dispatch(getForumConversation(15, 0, ForumThreadType.Activity, '', 'getForumConversation', 'get', undefined, undefined, ['getForumMessage'], this.props.actId ?? ""));
        }
    };

    public componentDidMount = () => {
        let threadType: ForumThreadType = ForumThreadType.Organization;
        if (this.props.classId) {
            threadType = ForumThreadType.Activity;
        }
        this.props.dispatch(getForumConversation(15, 0, threadType, this.props.classId!, 'getForumConversation', 'get', '', this.callBackFunction, ['getForumMessage'], this.props.actId ?? ""));
    };

    componentDidUpdate(prevProps: any) {
        const search = window.location.search;
        const params = queryString.parse(search.replace('?', ''));
        const activityId = params.actid ? String(params.actid) : null;
        const isFromCard = params.fromcard ? params.fromcard : false

        if (params.forumThreadId && this.props.forumConversation && this.props.forumConversation.length > 0 && this.props.forumConversation !== prevProps.forumConversation && !isFromCard) {
            this.loadClickedForumData(params.forumThreadId.toString());
        }
        else {
            if (this.props.forumConversation && this.props.forumConversation.length > 0 && this.props.forumConversation !== prevProps.forumConversation && !isFromCard) {
                this.loadClickedForumData(this.props.forumConversation[0].forumThreadId);
            }
        }


    }

    callBackFunction = (value: boolean) => {
        this.handleSearchQueryIfExists();
    }

    handleSearchQueryIfExists() {
        const search = window.location.search;
        const params = queryString.parse(search.replace('?', ''));
        const forumThreadId = params.forumThreadId ? String(params.forumThreadId) : null;
        const activityId = params.actid ? String(params.actid) : null;

        let returnStatus = false;
        if (activityId && this.props.forumConversation) {
            const forumList = document.querySelectorAll('a[data-actId=ID' + activityId + ']')[0];
            if (forumList) {
                const forumThread = forumList.getAttribute('data-threadid');

                if (forumThread != null) {
                    const threadId = forumThread.substring(2);
                    this.onForumThreadClick(null, threadId);
                    this.scrollToItem(forumList);
                    returnStatus = true
                }

            }

            return returnStatus;
        } else if (forumThreadId && this.props.forumConversation) {
            this.onForumThreadClick(null, forumThreadId);
            const forumListItem = document.querySelectorAll('a[data-threadId=ID' + forumThreadId + ']')[0];
            this.scrollToItem(forumListItem);
            return true;
        }
        return false;
    }

    scrollToItem(forumListItem: Element) {
        if (forumListItem) {
            forumListItem.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
    }

    public onForumThreadClick = (event: any, forumThreadId?: string) => {
        ReactGA.event({
            category: window.location.host,
            action: 'G_X_FORUM_CLICKED',
            label: 'G_X_FORUM_CLICKED',
            nonInteraction: true,
        });
        const forumContentBlock = document.getElementById('forum-content');
        if (forumContentBlock) {
            forumContentBlock.scrollTop = 0;
        }
        const _forumThreadId = forumThreadId ? forumThreadId : event.target!.getAttribute('data-id').toString();

        this.loadClickedForumData(_forumThreadId);

        const getForumMessageWindow = document.getElementById('getFormMessage_Window');
        if (getForumMessageWindow) {
            getForumMessageWindow.className = 'conversation-window mobile_chat_form_panel';
        }
    };

    public loadClickedForumData = (forumThreadId: string) => {
        const forumData = this.props.forumConversation!.filter(f => f.forumThreadId === forumThreadId)[0];
        this.setState({ selectedForum: forumThreadId });
        this.props.dispatch(getForumMessage(forumThreadId, forumData.subject, 0, 10, 'getForumMessage', 'get', '', false, this.callbackClickedForumdata(forumData)));
    };

    public callbackClickedForumdata = (forumData: any) => {

        const getForumContentWindow = document.getElementById('forum-content');
        if (getForumContentWindow) {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('hasModerator', forumData.hasModerator);
            window.history.replaceState(null, '', currentUrl.toString());
            getForumContentWindow.scrollTop = getForumContentWindow.scrollHeight;
        }

    }

    public onScrollDetected = (event: any) => {
        const element = event.target;
        if (element.scrollHeight - element.scrollTop === element.clientHeight) {
            let forumType: ForumThreadType = ForumThreadType.Organization;
            if (this.state.currentTab === 'general') {
                forumType = ForumThreadType.Organization;
            } else if (this.state.currentTab === 'course') {
                forumType = ForumThreadType.Activity;
            }
            if (this.props.classId) {
                forumType = ForumThreadType.Activity;
            }
            this.props.dispatch(
                getForumConversation(
                    this.props.forumTake!,
                    this.props.forumSkip! + 15,
                    forumType,
                    this.props.classId!,
                    'getForumConversationBox',
                    'get',
                    undefined,
                    undefined,
                    undefined,
                    this.props.actId ?? ""
                )
            );
        }
    };

    triggerSearchBox = () => {
        this.setState({
            isSearchBoxOpen: !this.state.isSearchBoxOpen,
            isSearchBoxShow: true
        });
    };

    getForumList = () => {
        let forumType: ForumThreadType = ForumThreadType.Organization;
        if (this.state.currentTab === 'general') {
            forumType = ForumThreadType.Organization;
        } else if (this.state.currentTab === 'course') {
            forumType = ForumThreadType.Activity;
        }
        if (this.props.classId) {
            forumType = ForumThreadType.Activity;
        }

        this.props.dispatch(
            getForumConversation(
                20,
                0,
                forumType,
                this.props.classId!,
                'getForumConversation',
                'get',
                this.state.searchedWord,
                undefined, undefined, this.props.actId ?? ""
            )
        );
    };

    searchOnChange = (event: React.ChangeEvent<HTMLInputElement>) => this.setState({ searchedWord: event.target.value });

    searchOnKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (this.state.searchedWord && this.state.searchedWord.length && event.keyCode === 13) {
            this.getForumList();
        }
    };

    searchOnClose = () => {
        this.state.searchedWord !== ''
            ? this.setState(
                {
                    searchedWord: '',
                    isSearchBoxOpen: !this.state.isSearchBoxOpen
                },
                () => {
                    this.getForumList();
                }
            )
            : this.triggerSearchBox();
    };

    viewSearchClass = () => {
        if (this.state.isSearchBoxOpen) {
            return " collapse  show slideInRight"
        }
        else {
            return " slideOutRight collapse ";
        }
    }

    render() {
        const loadingSpaces = 90;
        const loadingSizes = '0 0 315 800';
        const loadingWidth = 315;
        return (
            <div className="custom-col-forum-1">
                <div className="main-sidebar border-right pr-0" onScroll={this.onScrollDetected} style={{ overflowX: 'hidden' }}>
                    <div>
                        <div className="mt-0 active padding-t-0" style={{ background: 'rgba(0, 0, 0, 0.08)' }}>
                            <div className="mobile-message-search d-flex justify-content-between align-items-center"style={{padding:'.5em'}}>
                                <span style={{ fontSize: '1.25em', fontWeight: '500' }}>{T.t('r_menu_forum')}</span>
                                <div className="options d-inline-flex align-items-center">
                                    <a
                                        className='d-flex'
                                        data-toggle="collapse"
                                        href="#assignment-search"
                                        aria-expanded="true"
                                        onClick={this.triggerSearchBox}
                                    >
                                        <i className="material-icons">search</i>
                                    </a>
                                </div>
                            </div>



                        </div>

                        <div id="searchConversations" className={'mobile-message-input-search  search' + (this.state.isSearchBoxShow ? ' collapse show' : ' collapse')}>
                            <div className="input-group">
                                <div data-toggle="collapse" className="input-group-prepend" onClick={this.searchOnClose}>
                                    <div className="input-group-text">
                                        <i className="material-icons ">arrow_back</i>
                                    </div>
                                </div>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="inlineFormInputGroup"
                                    placeholder={T.t('r_gen_search')}
                                    value={this.state.searchedWord}
                                    onChange={this.searchOnChange}
                                    onKeyUp={this.searchOnKeyUp}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="announcementTabs" style={{ position: 'relative' }}>
                        {!this.props.classId && (
                            <ul className="nav nav-tabs border-0" style={{ paddingInlineStart: '0px' }} id="tabs" role="tablist">
                                <li className="nav-item">
                                    <a
                                        className={'nav-link' + (this.state.currentTab === 'general' && ' active')}
                                        onClick={this.onTabChange}
                                        data-tabtype="general"
                                    >
                                        {T.t('r_gen_general')}
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a
                                        className={'nav-link' + (this.state.currentTab === 'course' && ' active')}
                                        onClick={this.onTabChange}
                                        data-tabtype="course"
                                    >
                                        {T.t('r_activity_type_Course')}
                                    </a>
                                </li>
                            </ul>
                        )}
                        <Loading spinnerId={'getForumConversationBox'} type={'box'} position={'absolute'} />
                        <Loading spinnerId={'getForumConversation'}>
                            <div style={{ backgroundColor: '#eeede9' }}>
                                <ContentLoader
                                    speed={2}
                                    backgroundColor="#f3f3f3"
                                    foregroundColor="#ecebeb"
                                    viewBox={loadingSizes}
                                    style={{ width: '100%' }}
                                >
                                    <rect x="16" y="24" rx="3" ry="3" width="200" height="10" />
                                    <rect x="16" y="44" rx="3" ry="3" width="120" height="8" />
                                    <rect x="145" y="45" rx="3" ry="3" width="155" height="7" />
                                    <rect x="16" y="60" rx="3" ry="3" width="285" height="7" />
                                    <rect x="16" y="74" rx="3" ry="3" width="284" height="7" />
                                    <rect x={loadingWidth - (15 + 60)} y="24" rx="3" ry="3" width="60" height="10" />

                                    <rect x="16" y={24 + loadingSpaces} rx="3" ry="3" width="200" height="10" />
                                    <rect x="16" y={44 + loadingSpaces} rx="3" ry="3" width="120" height="8" />
                                    <rect x="145" y={45 + loadingSpaces} rx="3" ry="3" width="155" height="7" />
                                    <rect x="16" y={60 + loadingSpaces} rx="3" ry="3" width="285" height="7" />
                                    <rect x="16" y={74 + loadingSpaces} rx="3" ry="3" width="284" height="7" />
                                    <rect x={loadingWidth - (15 + 60)} y={24 + loadingSpaces} rx="3" ry="3" width="60" height="10" />

                                    <rect x="16" y={24 + loadingSpaces * 2} rx="3" ry="3" width="200" height="10" />
                                    <rect x="16" y={44 + loadingSpaces * 2} rx="3" ry="3" width="120" height="8" />
                                    <rect x="145" y={45 + loadingSpaces * 2} rx="3" ry="3" width="155" height="7" />
                                    <rect x="16" y={60 + loadingSpaces * 2} rx="3" ry="3" width="285" height="7" />
                                    <rect x="16" y={74 + loadingSpaces * 2} rx="3" ry="3" width="284" height="7" />
                                    <rect x={loadingWidth - (15 + 60)} y={24 + loadingSpaces * 2} rx="3" ry="3" width="60" height="10" />

                                    <rect x="16" y={24 + loadingSpaces * 3} rx="3" ry="3" width="200" height="10" />
                                    <rect x="16" y={44 + loadingSpaces * 3} rx="3" ry="3" width="120" height="8" />
                                    <rect x="145" y={45 + loadingSpaces * 3} rx="3" ry="3" width="155" height="7" />
                                    <rect x="16" y={60 + loadingSpaces * 3} rx="3" ry="3" width="285" height="7" />
                                    <rect x="16" y={74 + loadingSpaces * 3} rx="3" ry="3" width="284" height="7" />
                                    <rect x={loadingWidth - (15 + 60)} y={24 + loadingSpaces * 3} rx="3" ry="3" width="60" height="10" />

                                    <rect x="16" y={24 + loadingSpaces * 4} rx="3" ry="3" width="200" height="10" />
                                    <rect x="16" y={44 + loadingSpaces * 4} rx="3" ry="3" width="120" height="8" />
                                    <rect x="145" y={45 + loadingSpaces * 4} rx="3" ry="3" width="155" height="7" />
                                    <rect x="16" y={60 + loadingSpaces * 4} rx="3" ry="3" width="285" height="7" />
                                    <rect x="16" y={74 + loadingSpaces * 4} rx="3" ry="3" width="284" height="7" />
                                    <rect x={loadingWidth - (15 + 60)} y={24 + loadingSpaces * 4} rx="3" ry="3" width="60" height="10" />

                                    <rect x="16" y={24 + loadingSpaces * 5} rx="3" ry="3" width="200" height="10" />
                                    <rect x="16" y={44 + loadingSpaces * 5} rx="3" ry="3" width="120" height="8" />
                                    <rect x="145" y={45 + loadingSpaces * 5} rx="3" ry="3" width="155" height="7" />
                                    <rect x="16" y={60 + loadingSpaces * 5} rx="3" ry="3" width="285" height="7" />
                                    <rect x="16" y={74 + loadingSpaces * 5} rx="3" ry="3" width="284" height="7" />
                                    <rect x={loadingWidth - (15 + 60)} y={24 + loadingSpaces * 5} rx="3" ry="3" width="60" height="10" />

                                    <rect x="16" y={24 + loadingSpaces * 6} rx="3" ry="3" width="200" height="10" />
                                    <rect x="16" y={44 + loadingSpaces * 6} rx="3" ry="3" width="120" height="8" />
                                    <rect x="145" y={45 + loadingSpaces * 6} rx="3" ry="3" width="155" height="7" />
                                    <rect x="16" y={60 + loadingSpaces * 6} rx="3" ry="3" width="285" height="7" />
                                    <rect x="16" y={74 + loadingSpaces * 6} rx="3" ry="3" width="284" height="7" />
                                    <rect x={loadingWidth - (15 + 60)} y={24 + loadingSpaces * 6} rx="3" ry="3" width="60" height="10" />

                                    <rect x="16" y={24 + loadingSpaces * 7} rx="3" ry="3" width="200" height="10" />
                                    <rect x="16" y={44 + loadingSpaces * 7} rx="3" ry="3" width="120" height="8" />
                                    <rect x="145" y={45 + loadingSpaces * 7} rx="3" ry="3" width="155" height="7" />
                                    <rect x="16" y={60 + loadingSpaces * 7} rx="3" ry="3" width="285" height="7" />
                                    <rect x="16" y={74 + loadingSpaces * 7} rx="3" ry="3" width="284" height="7" />
                                    <rect x={loadingWidth - (15 + 60)} y={24 + loadingSpaces * 7} rx="3" ry="3" width="60" height="10" />

                                    <rect x="16" y={24 + loadingSpaces * 8} rx="3" ry="3" width="200" height="10" />
                                    <rect x="16" y={44 + loadingSpaces * 8} rx="3" ry="3" width="120" height="8" />
                                    <rect x="145" y={45 + loadingSpaces * 8} rx="3" ry="3" width="155" height="7" />
                                    <rect x="16" y={60 + loadingSpaces * 8} rx="3" ry="3" width="285" height="7" />
                                    <rect x="16" y={74 + loadingSpaces * 8} rx="3" ry="3" width="284" height="7" />
                                    <rect x={loadingWidth - (15 + 60)} y={24 + loadingSpaces * 8} rx="3" ry="3" width="60" height="10" />
                                </ContentLoader>
                            </div>
                        </Loading>
                        <div id="getForumConversation_Content" className="tab-content" style={{ backgroundColor: '#eeede9' }}>
                            {(this.props.forumConversation && this.props.forumConversation.length > 0) ? (
                                this.props.forumConversation.map((forumItem, index) => {
                                    return (
                                        <a
                                            key={index}
                                            onClick={this.onForumThreadClick}
                                            data-id={forumItem.forumThreadId}
                                            data-actId={'ID' + forumItem.activityId}
                                            data-threadId={'ID' + forumItem.forumThreadId}
                                            className="tab-pane fade show active"
                                            id="home"
                                            role="tabpanel"
                                            aria-labelledby="home-tab"
                                        >
                                            <div
                                                data-id={forumItem.forumThreadId}
                                                className={
                                                    'media' + (this.state.selectedForum === forumItem.forumThreadId ? ' active' : '')
                                                }
                                            >
                                                <div data-id={forumItem.forumThreadId} className="media-body" style={{ marginLeft: 0 }}>
                                                    <div data-id={forumItem.forumThreadId} className="message-intro pr-0">
                                                        <div data-id={forumItem.forumThreadId} className="row announcement-type">
                                                            <div data-id={forumItem.forumThreadId} className="col-9">
                                                                <span data-id={forumItem.forumThreadId}>
                                                                    <h5 data-id={forumItem.forumThreadId} className={(!_common.isArabic(forumItem.subject, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')}>
                                                                        {forumItem.courseName && forumItem.courseName + ' - '}{' '}
                                                                        {forumItem.subject}
                                                                    </h5>
                                                                </span>
                                                            </div>
                                                            <div data-id={forumItem.forumThreadId} className="col-3 text-right">
                                                                {forumItem.lastMessageDate
                                                                    ? Moment(forumItem.lastMessageDate).fromNow()
                                                                    : ''}
                                                            </div>
                                                        </div>
                                                        {forumItem.lastMessage ? (
                                                            <h6 data-id={forumItem.forumThreadId} className={"break-word" + (!_common.isArabic(forumItem.lastMessage, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')}>
                                                                <span data-id={forumItem.forumThreadId}>
                                                                    {forumItem.firstName + ' ' + forumItem.lastName}
                                                                </span>
                                                                :{' '}
                                                                <span
                                                                    data-id={forumItem.forumThreadId}
                                                                    className={"break-word"}
                                                                    style={{
                                                                        lineHeight: 1.145,
                                                                        textAlign: 'justify',
                                                                        textJustify: 'inter-word'
                                                                    }}
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: forumItem.lastMessage
                                                                            ? forumItem.lastMessage.length > 180
                                                                                ? forumItem.lastMessage
                                                                                    .slice(0, 180)
                                                                                    .replace(/<\/?[^>]+(>|$)/g, '') + ' ...'
                                                                                : forumItem.lastMessage.replace(/<\/?[^>]+(>|$)/g, '')
                                                                            : ''
                                                                    }}
                                                                />
                                                            </h6>
                                                        ) : (
                                                            <h6 data-id={forumItem.forumThreadId} className="break-word">
                                                                <span data-id={forumItem.forumThreadId}>
                                                                    {T.t('r_forum_forum_post_not_found')}
                                                                </span>
                                                            </h6>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    );
                                })) : (
                                <div className="media text-center">
                                    <h6>
                                        <span>{T.t('r_forum_forum_not_found')}</span>
                                    </h6>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IListForumProps) => {
    if (!state) {
        return ownProps;
    }

    const newProps: IListForumProps = Object.assign({}, ownProps, {
        forumConversation: state.forum.forumConversation,
        forumTake: state.forum.forumTake,
        forumSkip: state.forum.forumSkip,
        actId: state.coursePage.coursePageActivityId
    });

    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.forum.forumConversation === prev.forum.forumConversation &&
        next.forum.forumTake === prev.forum.forumTake &&
        next.forum.forumSkip === prev.forum.forumSkip;
    return ret;
};

const CListForum = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(ListForum);

export default CListForum;
